import apiConfig from "constants/apiConfig"
import axiosClient from "utils/axiosClient"

export const fetchRegions = async () => {
    const response = await axiosClient.get(apiConfig.FETCH_REGIONS.url);
    return response.data.results;
}